/**
 * @description Registers global styles that style all FilePond components
 */

import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';

const styles = (
  <GlobalStyles styles={() => (
    {
      'table td': {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
      }
    }
  )}
  />
);

export default styles;
